import { PlusOutlined, SearchOutlined } from "@ant-design/icons";
import { getIsQuotaManagementEnabled } from "app-redux/selectors/rollout.selector";
import arrowBack from "assets/icons/arrowBack.svg";
import { RoutePaths, history } from "core/history";
import React from "react";
import { useSelector } from "react-redux";
import {
  Button,
  ButtonType,
  Input,
} from "syngenta-digital-cropwise-react-ui-kit";
import { getCurrentSelectedPage } from "utils/common-methods";
import { SelectedPages } from "utils/enums";
import { ShowAllOrganizationDropdown } from "../../ShowAllOrganizationDropdown";
import "./styles.less";

export const WorkspaceDetailsHeader = (props: {
  t: any;
  actionButton: any;
  title: string;
  currentWorkspaceId: any;
  setSearchTerm: (input: string) => void;
  handleFilterChange?: (checkedList: []) => void;
  resetCurrentWorkspace: () => void;
}) => {
  const isQuotaManagementEnabled = useSelector(getIsQuotaManagementEnabled);
  const {
    t,
    setSearchTerm,
    handleFilterChange,
    actionButton,
    title,
    currentWorkspaceId,
  } = props;

  const redirectToAccountsPage = () => {
    history.replace(RoutePaths.WORKSPACES(currentWorkspaceId));
    props.resetCurrentWorkspace();
  };

  const isMembersPage = getCurrentSelectedPage() === SelectedPages.MEMBERS;

  return (
    <div
      data-testid="workspace-details-header-container-testid"
      className="workspace-details-header-container products-page-header"
    >
      <div style={{ display: "flex" }}>
        <div
          className="products-page-left-arrow"
          onClick={() => redirectToAccountsPage()}
        >
          <img src={arrowBack} alt="Go Back" />
        </div>
        <span style={{ textTransform: "capitalize" }}>{t(title)}</span>
      </div>
      <div className="products-page-search">
        <div style={{ flex: 1 }}>
          <Input
            placeholder={t("global.place_holder.search_by_name")}
            size="large"
            maxLength={50}
            prefix={<SearchOutlined />}
            onChange={(e) => setSearchTerm(e.target.value)}
            allowClear={true}
            style={{ width: "312px", flex: 1 }}
          />
        </div>
        {isMembersPage && (
          <ShowAllOrganizationDropdown
            handleFilterChange={handleFilterChange}
            currentWorkspaceId={currentWorkspaceId}
          />
        )}
      </div>
      {actionButton && (
        <div className="products-page-activate-new-plan">
          {isQuotaManagementEnabled && !isMembersPage && (
            <Button
              className="products-page-manage-quota"
              type={ButtonType.outline}
              size="middle"
              onClick={() => {
                history.push({
                  pathname: RoutePaths.QUOTA_MANAGEMENT(),
                  search: location.search,
                });
              }}
            >
              <span>{t("button.manage_quota")}</span>
            </Button>
          )}
          <Button
            className="products-page-activate-new-plan-btn"
            type={ButtonType.outline}
            size="middle"
            data-testid="products-page-activate-new-plan-btn-testid"
            disabled={actionButton.disabled}
            icon={<PlusOutlined />}
            style={actionButton.disabled ? {
              background: 'whitesmoke',
              color: '#c1c5c8',
              cursor: 'not-allowed'
            } : {}}
            onClick={actionButton.click}
          >
            <span>{t(actionButton.title)}</span>
          </Button>
        </div>
      )}
    </div>
  );
};
